import { render, staticRenderFns } from "./AccountEmailBuilder.vue?vue&type=template&id=0ac47612"
import script from "./AccountEmailBuilder.vue?vue&type=script&lang=js"
export * from "./AccountEmailBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports